@if (dialogs.activeDialog(); as dialog) {
  @if (dialog.nodeKind === "cad_input") {
    @if (hasCadInputSelection(dialog.nodeId)) {
      <app-cad-input-node-config-dialog
        [nodeId]="dialog.nodeId"
        [visible]="true"
        (visibleChange)="onVisibleChange($event)"
      />
    } @else {
      <app-cad-input-picker-dialog
        [nodeId]="dialog.nodeId"
        [visible]="true"
        (visibleChange)="onVisibleChange($event)"
      />
    }
  } @else if (dialog.nodeKind === "pull_direction") {
    <app-pull-direction-node-config-dialog
      [nodeId]="dialog.nodeId"
      [visible]="true"
      (visibleChange)="onVisibleChange($event)"
    />
  } @else if (dialog.nodeKind === "dfm_check") {
    <app-dfm-check-node-config-dialog
      [nodeId]="dialog.nodeId"
      [visible]="true"
      (visibleChange)="onVisibleChange($event)"
    />
  } @else if (isGeometryProcessingNodeKind(dialog.nodeKind)) {
    <app-processing-step-node-config-dialog
      [nodeId]="dialog.nodeId"
      [nodeKind]="dialog.nodeKind"
      [visible]="true"
      (visibleChange)="onVisibleChange($event)"
    />
  }
}
